module.exports = __webpack_public_path__ + "static/media/he.741c40ac.png";